module.exports = __webpack_public_path__ + "img/folder-closed.b25b907f.svg";